import BaseProxy from "../../../base-proxy";

/**
 * @class ChangeOfDirectorProxy
 * @description KYC workflow endpoints
 * @author Jonathan Sumiguin
 * @version 1.0
 * @since July 29, 2019
 */
export default {
  /**
   * @async
   * @function execute
   * @param input Input parameter.
   * @param {String} input.authToken Token used for issuing authenticated request.
   * @param {Object} input.payload payload form
   */
  async changeOfDirectorStart(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/workflow/api/tasks/changeofdirector/start`;
    if (input.camunda) {
      endpointUrl = `${backendUrl}/v2/sleek-workflow/change-of-director/start`;
    }

    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  },
};
